import { NavigationBarLink } from '@everlywell/consumer-ui';
import analytics from 'utils/analytics';
import { ANALYTICS } from 'utils/constants/analytics';

export const NavigationTracking = {
  trackOpenCart: () => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: ANALYTICS.NAVIGATION_V2.OPEN_CART,
        component: ANALYTICS.NAVIGATION_V2.COMPONENT,
      },
    });
  },

  trackOpenSearch: () => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: ANALYTICS.NAVIGATION_V2.OPEN_SEARCH,
        component: ANALYTICS.NAVIGATION_V2.COMPONENT,
      },
    });
  },

  trackLinkClick: (linkLabel: string) => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_LINK,
      data: {
        label: ANALYTICS.NAVIGATION_V2.LINK_CLICK,
        component: ANALYTICS.NAVIGATION_V2.COMPONENT,
        link: linkLabel,
      },
    });
  },

  trackOpenCategory: (categoryLabel: string) => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: ANALYTICS.NAVIGATION_V2.OPEN_CATEGORY,
        component: ANALYTICS.NAVIGATION_V2.COMPONENT,
        category: categoryLabel,
      },
    });
  },

  trackRegisterKitClick: () => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_LINK,
      data: {
        label: ANALYTICS.NAVIGATION_V2.REGISTER,
        component: ANALYTICS.NAVIGATION_V2.COMPONENT,
      },
    });
  },

  trackMobileMenuOpen: () => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: ANALYTICS.NAVIGATION_V2.OPEN_MOBILE_MENU,
        component: ANALYTICS.NAVIGATION_V2.COMPONENT,
      },
    });
  },

  trackBackToMainMenu: () => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: ANALYTICS.NAVIGATION_V2.BACK_TO_MAIN_MENU,
        component: ANALYTICS.NAVIGATION_V2.COMPONENT,
      },
    });
  },

  trackOnProfileClick: () => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_LINK,
      data: {
        label: ANALYTICS.NAVIGATION_V2.PROFILE,
        component: ANALYTICS.NAVIGATION_V2.COMPONENT,
      },
    });
  },

  trackSearchCallback: (query: string, results: NavigationBarLink[]) => {
    analytics.track({
      event: ANALYTICS.EVENTS.NAV_SEARCH_PERFORMED,
      data: {
        component: ANALYTICS.NAVIGATION_V2.COMPONENT,
        searchQuery: query,
        // Send a list labels with the search results
        searchResults: results.map((result) => result.label),
      },
    });
  },

  trackLogoClick: () => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_LINK,
      data: {
        label: ANALYTICS.NAVIGATION_V2.LOGO_CLICK,
        component: ANALYTICS.NAVIGATION_V2.COMPONENT,
      },
    });
  },

  trackSpotlightClick: (spotlightLabel: string) => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: ANALYTICS.NAVIGATION_V2.SPOTLIGHT_CLICK,
        component: ANALYTICS.NAVIGATION_V2.COMPONENT,
        spotlight: spotlightLabel,
      },
    });
  },

  trackMainDrawerButtonClick: (buttonLabel: string) => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: ANALYTICS.NAVIGATION_V2.MAIN_BUTTON_DRAWER_CLICK,
        component: ANALYTICS.NAVIGATION_V2.COMPONENT,
        buttonLabel,
      },
    });
  },

  trackShopAllSearchProductsClick: () => {
    analytics.track({
      event: ANALYTICS.EVENTS.CLICKED_BUTTON,
      data: {
        label: ANALYTICS.NAVIGATION_V2.SHOP_ALL_SEARCH,
        component: ANALYTICS.NAVIGATION_V2.COMPONENT,
      },
    });
  },
};
